export const HELLO_WORLD = "HELLO_WORLD";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW";

export const SET_ACTIVE_APP = "SET_ACTIVE_APP";

export const INITIALIZE = "INITIALIZE";

export const SET_INITIALIZED = "SET_INITIALIZED";

export const SET_ACTIVE_STORE = "SET_ACTIVE_STORE";

export const helloWorld = (payload) => ({ type: HELLO_WORLD, payload });
export const setActiveTab = (payload) => ({ type: SET_ACTIVE_TAB, payload });
export const setActiveView = (payload) => ({ type: SET_ACTIVE_VIEW, payload });
export const setActiveApp = (payload) => ({ type: SET_ACTIVE_APP, payload });

export const initialize = () => ({ type: INITIALIZE });
export const setInitialized = (payload) => ({ type: SET_INITIALIZED, payload });
export const setActiveStore = (payload) => ({
  type: SET_ACTIVE_STORE,
  payload,
});

//USER INFO ACTIONS
export const USER_INFO_REQUEST = "USER_INFO_REQUEST";
export const USER_INFO_REQUEST_SUCCEED = "USER_INFO_REQUEST_SUCCEED";
export const USER_INFO_REQUEST_FAILED = "USER_INFO_REQUEST_FAILED";

export const userInfoRequest = () => ({ type: USER_INFO_REQUEST });
export const userInfoRequestSucceed = (payload) => ({
  type: USER_INFO_REQUEST_SUCCEED,
  payload,
});
export const userInfoRequestFailed = (payload) => ({
  type: USER_INFO_REQUEST_FAILED,
  payload,
});

//role access
//USER INFO ACTIONS
export const USER_ROLE_ACCESS_REQUEST = "USER_ROLE_ACCESS_REQUEST";
export const USER_ROLE_ACCESS_REQUEST_SUCCEED =
  "USER_ROLE_ACCESS_REQUEST_SUCCEED";
export const USER_ROLE_ACCESS_REQUEST_FAILED =
  "USER_ROLE_ACCESS_REQUEST_FAILED";

export const userRoleAccessRequest = () => ({ type: USER_ROLE_ACCESS_REQUEST });
export const userRoleAccessRequestSucceed = (payload) => ({
  type: USER_ROLE_ACCESS_REQUEST_SUCCEED,
  payload,
});
export const userRoleAccessRequestFailed = (payload) => ({
  type: USER_ROLE_ACCESS_REQUEST_FAILED,
  payload,
});

//user store actions
//USER INFO ACTIONS
export const GET_USER_STORES_REQUEST = "GET_USER_STORES_REQUEST";
export const USER_STORES_REQUEST = "USER_STORES_REQUEST";
export const USER_STORES_REQUEST_SUCCEED = "USER_STORES_REQUEST_SUCCEED";
export const USER_STORES_REQUEST_FAILED = "USER_STORES_REQUEST_FAILED";

export const getUserStoreRequest = () => ({ type: GET_USER_STORES_REQUEST });
export const userStoreRequest = () => ({ type: USER_STORES_REQUEST });
export const userStoreRequestSucceed = (payload) => ({
  type: USER_STORES_REQUEST_SUCCEED,
  payload,
});
export const userStoreRequestFailed = (payload) => ({
  type: USER_STORES_REQUEST_FAILED,
  payload,
});

//USER INFO ACTIONS
export const GET_USER_PLAN_REQUEST = "GET_USER_PLAN_REQUEST";
export const USER_PLAN_REQUEST = "USER_PLAN_REQUEST";
export const USER_PLAN_REQUEST_SUCCEED = "USER_PLAN_REQUEST_SUCCEED";
export const USER_PLAN_REQUEST_FAILED = "USER_PLAN_REQUEST_FAILED";

export const getUserPlanRequest = () => ({ type: GET_USER_PLAN_REQUEST });
export const userPlanRequest = () => ({ type: USER_PLAN_REQUEST });
export const userPlanRequestSucceed = (payload) => ({
  type: USER_PLAN_REQUEST_SUCCEED,
  payload,
});
export const userPlanRequestFailed = (payload) => ({
  type: USER_PLAN_REQUEST_FAILED,
  payload,
});
